<template>
	<v-dialog v-model="dialog" scrollable persistent max-width="390">
		<CardDialogPersonalizado>
			<p><b>Você realmente deseja excluir esse usuário?</b></p>
			<v-row class="mt-2">
				<v-col cols="6">
					<v-btn class="red--text" @click="excluirItens()" large width="100%">
						<v-icon left> mdi-delete </v-icon>
						SIM
					</v-btn>
				</v-col>
				<v-col cols="6">
					<v-btn
						class="botao white--text mt-pa"
						@click="fecharDialog()"
						color="#CC2128"
						large
						elevation="9"
						width="100%"
					>
						<v-icon left> mdi-close </v-icon>
						Não
					</v-btn>
				</v-col>
			</v-row>
		</CardDialogPersonalizado>
	</v-dialog>
</template>

<script>
import CardDialogPersonalizado from '../shared/dialogPersonalizado.vue'
export default {
	props: {
		abrirDialog: Boolean,
		id: String,
	},
	components: {
		CardDialogPersonalizado,
	},
	computed: {
		dialog: {
			get() {
				return this.abrirDialog
			},
			set() {
				this.fecharDialog()
			},
		},
	},
	methods: {
		fecharDialog() {
			this.$emit('fecharDialog')
		},
		async excluirItens() {
			try {
				const response = await this.axios.delete(`/usuarios/${this.id}`)
				if (response.status == 204) {
					this.$store.dispatch('showSuccess', 'Usuário excluído com sucesso!')
					this.fecharDialog()
					this.$emit('fecharTodosDialogs')
				}
			} catch (error) {
				this.$store.dispatch('showError', error)
			} finally {
				this.loading = false
			}
		},
	},
}
</script>


